import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_SINGLE_CLIENT_REPORT_ENTRIES_COUNT } from "../../types";
import {
  getSingleClientReportEntriesCountPending,
  getSingleClientReportEntriesCountFulfilled,
  getSingleClientReportEntriesCountRejected,
  setNoEntriesMessage,
} from "../../actions";
import { sendApiRequest, notifyError } from "../../../../actions";
import { SINGLE_CLIENT_REPORT_ENTRIES_LOG_MESSAGES } from "../../constants/singleClientEntriesReportConstants";
import generateError from "../../../../utilities/generateError";

const createPayload = (payload) => ({
  method: "post",
  url: "report/countsingleclientspost",
  onSuccess: [
    (response) =>
      response.data === 0
        ? setNoEntriesMessage(
            SINGLE_CLIENT_REPORT_ENTRIES_LOG_MESSAGES.NOT_FOUND
          )
        : { type: "" },
    (response) => getSingleClientReportEntriesCountFulfilled(response),
  ],
  onError: [
    getSingleClientReportEntriesCountRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getSingleClientReportEntriesCountEpic$ = (action$) =>
  action$.pipe(
    ofType(GET_SINGLE_CLIENT_REPORT_ENTRIES_COUNT.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) =>
      merge(
        of(getSingleClientReportEntriesCountPending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );

export default getSingleClientReportEntriesCountEpic$;



// WEBPACK FOOTER //
// ./src/features/reports/epics/single-client/getSingleClientReportEntriesCountEpic.js